import { PDFDocument } from 'pdf-lib';
import { MarginType } from './PdfBanner';

export const margin = (
  elementTransformations: ElementTransformations,
): MarginType => [
  elementTransformations.right
    ? 'right'
    : elementTransformations.margin === 'initial'
      ? 'left'
      : elementTransformations.margin === 'auto auto auto 0'
        ? 'left'
        : 'center',
  'center',
];

export const mergePDFDocuments = async (
  document: PDFDocument,
  newDocument: PDFDocument,
  copies: number,
): Promise<PDFDocument> => {
  const mergedPdf = await PDFDocument.create();

  const copiedPagesFromDocument = await mergedPdf.copyPages(
    document,
    document.getPageIndices(),
  );
  copiedPagesFromDocument.forEach((page) => mergedPdf.addPage(page));

  for (let i = 0; i < copies; i++) {
    const copiedPagesFromNewDocument = await mergedPdf.copyPages(
      newDocument,
      newDocument.getPageIndices(),
    );
    copiedPagesFromNewDocument.forEach((page) => mergedPdf.addPage(page));
  }

  return mergedPdf;
};

